import { sendRequestJson } from "@/utils";

class ProductOrderRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	/**
	 * Mark product order(s) as preparing.
	 * @param {string|string[]} productOrderIds - Single ID or array of IDs
	 */
	async markAsPreparingProductOrder(productOrderIds) {
		const url = this.urlBase + "/world/api/productorder/startpreparation";
		const ids = Array.isArray(productOrderIds) ? productOrderIds : [productOrderIds];
		try {
			return await sendRequestJson({ data: { productOrderIds: ids }, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal marcando el pedido como preparando");
		}
	}

	async toggleMenuIncluded(data) {
		const url = this.urlBase + "/world/api/productorder/toggle-menu-included";
		try {
			return await sendRequestJson({ data, url, method: "PATCH" });
		} catch (e) {
			console.log("Ups, algo ha ido mal cambiando el producto a menú");
		}
	}

	/**
	 * Add product order(s) to hot table.
	 * @param {string|string[]} productOrderIds - Single ID or array of IDs
	 */
	async addProductOrderToHotTable(productOrderIds) {
		const url = this.urlBase + "/world/api/productorder/addtohottable";
		const ids = Array.isArray(productOrderIds) ? productOrderIds : [productOrderIds];
		try {
			return await sendRequestJson({ data: { productOrderIds: ids }, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal añadiendo a la hot table");
		}
	}

	/**
	 * Remove product order(s) from hot table.
	 * @param {string|string[]} productOrderIds - Single ID or array of IDs
	 */
	async removeProductOrderFromHotTable(productOrderIds) {
		const url = this.urlBase + "/world/api/productorder/removetohottable";
		const ids = Array.isArray(productOrderIds) ? productOrderIds : [productOrderIds];
		try {
			return await sendRequestJson({ data: { productOrderIds: ids }, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal eliminando de la hot table");
		}
	}

	async finishPreparation(data) {
		const url = this.urlBase + "/world/api/productorder/finishpreparation";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal finalizando el pedido");
		}
	}

	async serveProductOrders(data) {
		const url = this.urlBase + "/world/api/productorder/serve";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal sirviendo el pedido");
		}
	}

	async dispatchFireableProductOrders(data) {
		const url = this.urlBase + "/world/api/productorder/dispatch-fireable";
		try {
			return await sendRequestJson({ data, url, method: "POST" });
		} catch (e) {
			console.log("Ups, algo ha ido mal al marchar el dishClass");
		}
	}

	/**
	 * Fetches the served-history batches from the backend.
	 * @param {number} page - Page number (1-indexed)
	 * @param {number} limit - Number of batches per page
	 * @param {string|null} date - Target date in YYYY-MM-DD format
	 * @param {string|null} before - Cursor for pagination (ISO date string)
	 * @returns {Promise<{batches: Array, page: number, hasMore: boolean}>}
	 */
	async getServedHistory(page = 1, limit = 5, date = null, before = null) {
		let url = this.urlBase + `/world/api/product-orders/served-history?page=${page}&limit=${limit}`;
		if (date) {
			url += `&date=${date}`;
		}
		if (before) {
			url += `&before=${encodeURIComponent(before)}`;
		}
		try {
			return await sendRequestJson({ url, method: "GET" });
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo el historial de servidos");
			return { batches: [], page };
		}
	}

	async getServiceEventsHistory({ date = null, productOrderStatus = 100, limit = 10, before = null } = {}) {
		let url = this.urlBase + `/world/api/history/service-events?productOrderStatus=${productOrderStatus}&limit=${limit}`

		if (date) {
			url += `&date=${encodeURIComponent(date)}`
		}

		if (before) {
			url += `&before=${encodeURIComponent(before)}`
		}

		try {
			return await sendRequestJson({ url, method: "GET" })
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo el historial de service events")
			return []
		}
	}
}

export const productOrderRepository = new ProductOrderRepository();
